module.exports = __webpack_public_path__ + "img/jwgl-jcsj-njsj.09b398ff.png";